import { GridActionsCellItem, } from '@mui/x-data-grid';
import PermissionHOC from 'components/Permissions/PermissionHOC';

/**
 * GridAction (MUI DataGrid action cell)
 * Icon button for row actions inside MUI DataGrid `actions` columns.
 * Wrapped with `PermissionHOC` for permission-based visibility.
 *
 * **How it works**
 * - Renders `GridActionsCellItem` with a custom icon component.
 * - `action(props)` receives the full props object on click (same pattern as `Button`).
 * - `label` is fixed to `"Edit"` (MUI accessibility label).
 *
 * Exported as `GridAction` from `components/Form`.
 *
 * @param {Object} props
 * @param {Function} props.action - Click handler. Receives `(props)`.
 * @param {React.ComponentType} props.icon - Icon component rendered as `<props.icon />`.
 * @param {string} [props.color] - MUI action color (e.g. `primary`, `inherit`).
 * @param {string} [props.permissionHOC] - Permission wrapper key (e.g. `hidden`).
 * @example
 * <GridAction icon={EditIcon} color="primary" action={(props) => handleEdit(props.row)} />
 */
const GridAction = (props) => {
    const { action, color } = props

    return (
        <GridActionsCellItem
            icon={<props.icon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
                action(props)
            }}
            color={color}
        />
    )
}

export default PermissionHOC(GridAction)

